import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Loading from '../components/common/Loading';
import ArtistBalance from '../pages/ArtistBalance/ArtistBalance';
import { MdPeople } from "react-icons/md";
import { FaRegCreditCard } from "react-icons/fa6";
import PayoutHistory from '../pages/PaymentMangement/PayoutHistory';
import { MdAdminPanelSettings } from "react-icons/md";

// Lazy load components
const ProtectedRoute = lazy(() => import('./Protectedroute'));
const Layout = lazy(() => import('../components/layout/Layout'));
const Dashboard = lazy(() => import('../pages/Dashboard/IndexPage'));
const IndexLogin = lazy(() => import('../pages/Login/IndexLogin'));
const ForgotPasswordIndex = lazy(() => import('../pages/Forgotpassword/ForgetPassIndex'));
const NotFound = lazy(() => import('../components/common/NotFound'));
const AdminManagement = lazy(() => import('../pages/AdminManagement/AdminManagement'));
const ArtistDetail = lazy(() => import('../pages/ArtistBalance/compoent/ArtistDetail'));
const PublicRoute = lazy(() => import('./PublicRoute'));


// Error Boundary Component
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh',
                    backgroundColor: '#0A0A0A',
                    color: '#fff',
                    textAlign: 'center',
                    padding: '20px'
                }}>
                    <div>
                        <h1>Something went wrong.</h1>
                        <button
                            onClick={() => window.location.href = '/'}
                            style={{
                                marginTop: '20px',
                                padding: '10px 20px',
                                backgroundColor: '#F5A623',
                                color: '#000',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontWeight: 600,
                            }}
                        >
                            Go to Home
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export const menuItems = [
    { text: 'User Management', icon: <MdPeople size={24} />, path: '/dashboard' },
    { text: 'Artist Balance', icon: <MdPeople size={24} />, path: '/artist-balance' },
    { text: 'Payout Management', icon: <FaRegCreditCard size={24} />, path: '/payout-history' },
    { text: 'Admin Management', icon: <MdAdminPanelSettings size={24} />, path: '/admin-management' },
] 

const AppRoutes = () => {
    return (
        <ErrorBoundary>
            <Suspense fallback={<Loading message="Loading page..." />}>
                <Routes>
                    {/* Public Routes */}
                    <Route
                        path="/login"
                        element={
                            <Suspense fallback={<Loading />}>
                                {/* <PublicRoute> */}
                                    <IndexLogin />
                                {/* </PublicRoute> */}
                            </Suspense>
                        }
                    />
                    <Route
                        path="/forgot-password"
                        element={
                            <Suspense fallback={<Loading />}>
                                <ForgotPasswordIndex />
                            </Suspense>
                        }
                    />

                    {/* Protected Routes with Layout */}
                    <Route
                        path="/"
                        element={
                            <Suspense fallback={<Loading />}>
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            </Suspense>
                        }
                    >
                        {/* Nested routes - will render inside Layout's Outlet */}
                        <Route index element={<Navigate to="/dashboard" replace />} />
                        <Route
                            path="dashboard"
                            element={
                                <Suspense fallback={<Loading />}>
                                    <Dashboard />
                                </Suspense>
                            }
                        />
                        <Route
                            path="/artist-balance"
                            element={
                                <Suspense fallback={<Loading />}>
                                    <ArtistBalance />
                                </Suspense>
                            }
                        />
                        <Route
                            path="/artist-balance/:id"
                            element={
                                <Suspense fallback={<Loading />}>
                                    <ArtistDetail />
                                </Suspense>
                            }
                        />
                        <Route
                            path="/payout-history"
                            element={
                                <Suspense fallback={<Loading />}>
                                    <PayoutHistory />
                                </Suspense>
                            }
                        />
                        <Route
                            path="/admin-management"
                            element={
                                <Suspense fallback={<Loading />}>
                                    <AdminManagement />
                                </Suspense>
                            }
                        />
                    </Route>

                    {/* 404 Not Found */}
                    <Route
                        path="/not-found"
                        element={
                            <Suspense fallback={<Loading />}>
                                <NotFound />
                            </Suspense>
                        }
                    />

                    {/* Catch all - redirect to 404 */}
                    <Route path="*" element={<Navigate to="/not-found" replace />} />
                </Routes>
            </Suspense>
        </ErrorBoundary>
    );
};

export default AppRoutes;